// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overview{padding:20px 74px 74px}.overview SPAN.search-icon{margin-left:-45px!important}.overview .tab-context-actions i:not(.not-allowed){border:1px solid transparent;border-radius:4px;cursor:pointer;padding:3px}.overview .tab-context-actions i:not(.not-allowed):hover{background:rgba(104,96,228,.039);border:1px solid #dee2e6}", ""]);
// Exports
module.exports = exports;
